__turbopack_context__.v({
  "className": "ubuntu_76edb2b7-module__4KObiq__className",
});
